var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vg-heading',[_vm._v("申请进度")]),_c('vg-card',{staticClass:"padding"},[_c('vg-text-track',{attrs:{"value":_vm.value}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }